import classnames from 'classnames'
import React from 'react'

import { SelectedFilter } from '../../domains/CollectionFilter'

import styles from './noProducts.module.scss'

interface NoProductProps {
  className?: string
  onResetFilters: (selectedFilters: SelectedFilter) => void
}

const NoProduct = (props: NoProductProps) => {
  const classes = classnames(styles.wrapper, props.className)
  return (
    <div className={classes}>
      <div className={styles.header}>No product found</div>
      <div className={styles.reset}>
        <u
          onClick={() => {
            props.onResetFilters(new SelectedFilter({}))
          }}
        >
          Reset filter
        </u>
      </div>
    </div>
  )
}
export default NoProduct
